export const meso = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 });
export const dateTime = new Intl.DateTimeFormat(undefined, { dateStyle: 'medium', timeStyle: 'short' });

export function formatMeso(value: number): string { return meso.format(Math.round(value)); }
